// extracted by mini-css-extract-plugin
export default {"link":"ProcessesColumn_link__jJUga","nonlink":"ProcessesColumn_nonlink__Np+SR"};